import { IconButtonProps, IconButton, styled } from "@mui/material";
import "./IconButtonBorder.css";

const IconButtonBorder = styled(IconButton)<IconButtonProps>(({ theme }) => ({
    color: theme.palette.mode == "light"? 'white' : 'gray',
    borderWidth:"1px",
    borderStyle:"solid",
    borderColor: theme.palette.mode == "light"? "white":"#525151",
    '&:hover': {
      backgroundColor: "#02ad76",
    },
  }));
export default IconButtonBorder;